export default "__VITE_ASSET__DFGTclko__"